import ErrorBoundary from './Components/ErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
// import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.css'
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './Redux/Stores/Store';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

 import { loadConfig } from './Asset/config';

// /////////MB Load Config And Get Base API From Config.json/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function initializeApp() {
  try { 

    await loadConfig();    
    const root = ReactDOM.createRoot(document.getElementById('root'));    
    root.render(
      <ErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </ErrorBoundary>
    );
    
    reportWebVitals();
  } catch (error) {
    console.error('Failed to initialize application:', error);
    // You can render an error state here if needed
    const errorRoot = ReactDOM.createRoot(document.getElementById('root'));
    errorRoot.render(
      <div style={{ padding: '20px', color: 'red' }}>
        <h1>Application Failed to Initialize</h1>
        <p>{error.message}</p>
      </div>
    );
  }
}
// Start the application initialization
initializeApp();

// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// ////////Close By MB//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////Old Code
// const root = ReactDOM.createRoot(document?.getElementById('root'));
// root.render(
//   // Hello
//   // <React.StrictMode>
//       <ErrorBoundary>
//       <Provider store={store}>
//         <App />
//       </Provider>
//      </ErrorBoundary>     
//   // </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
